module.exports = __webpack_public_path__ + "img/etairies-bottom-left.3aef871c.png";